import { render, staticRenderFns } from "./PaymentLink.vue?vue&type=template&id=2fe1882b&scoped=true"
import script from "./PaymentLink.vue?vue&type=script&lang=js"
export * from "./PaymentLink.vue?vue&type=script&lang=js"
import style0 from "./PaymentLink.vue?vue&type=style&index=0&id=2fe1882b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe1882b",
  null
  
)

export default component.exports